import type { PropsWithChildren } from 'preact/compat';
import './Collapsible.less';
import { useRef, useState, useEffect } from 'preact/hooks';

export type CollapsibleProps = PropsWithChildren<{
    isOpen: boolean;
}>;

const Collapsible = ({ children, isOpen }: CollapsibleProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number>(0);
    const [opacity, setOpacity] = useState<number>(0);
    useEffect(() => {
        if (!isOpen) {
            return setHeight(0);
        }
        const timeout = setTimeout(() => {
            if (ref.current && isOpen) {
                setHeight((ref.current.firstChild as HTMLElement).scrollHeight);
                setOpacity(1);
            }
        }, 100);
        return () => clearTimeout(timeout);
    }, [isOpen]);
    return (
        <div ref={ref} className="bri-Collapsible" style={{ height, opacity }}>
            {children}
        </div>
    );
};

export default Collapsible;
